module.exports = __webpack_public_path__ + "static/media/cvc.28d8f6db.svg";